export default __webpack_public_path__ + "static/media/social-info.8eb4dbe1.png";